// extracted by mini-css-extract-plugin
export default {"hypnotic_loader":"styles_hypnotic_loader__3vJjM","loadhypnotic":"styles_loadhypnotic__OHBRN","loader_all":"styles_loader_all__vudUE"};